export const AttachOrigin = {
    REGISTRATION: "registration",
    FACE: "face",
    ENCOUNTER: "encounter",
};

export const ATTACH_ORIGINS = [
    AttachOrigin.ENCOUNTER,
    AttachOrigin.REGISTRATION,
    AttachOrigin.FACE,
];

export const getAttachOrigin = (attach, individual) => {
    if (attach?.attachId && (attach.attachId === individual?.relatedPhotoFaceId || attach?.datePhotoFace)) return AttachOrigin.FACE;

    return attach?.from?.toLowerCase() || AttachOrigin.REGISTRATION;
};

export const getAttachOriginLabel = (origin) => ({
    [AttachOrigin.REGISTRATION]: "Cadastro",
    [AttachOrigin.FACE]: "Foto da face",
    [AttachOrigin.ENCOUNTER]: "Abordagem",
}[origin] ?? "Outra origem");